import React from "react";
export const loginHelp = {
    recordDoesNotMatch: "The details you've entered do not match our records. Please verify and try again.",
    accountBlocked: "Your account has been blocked. ",
    incorrectPIN: "PIN does not match. Re-enter your PIN.",
    mobOrEmailInvalid: "Seems like you have entered an incorrect mobile number or email ID. Please try again.",
    invalidID: "Invalid Login ID",
    invalidPassword: "Incorrect Password",
    invalidOTP: "Invalid OTP",
    emailAddExist: (React.createElement(React.Fragment, null,
        React.createElement("span", null,
            "This email ID has already been linked to an existing account. ",
            React.createElement("br", null),
            "If you already have an account click here to"))),
};
